import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.45fafcbf-0767-4ca2-852c-f3bfba6b1b50/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.45fafcbf-0767-4ca2-852c-f3bfba6b1b50/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";
// ignore-string-externalization
import { NotFound } from '../../../features/Layout';
import { getArticlePageData } from '../../../features/Help/getHelpData';
import React from 'react';
import { HelpArticleTemplate } from '../../../features/Template/Help/HelpArticleTemplate';
import { jsx as _jsx } from "react/jsx-runtime";

var HelpListPage = function HelpListPage(_ref) {
  var template = _ref.template,
      faq = _ref.faq,
      category = _ref.category,
      preview = _ref.preview;

  if (!template || !faq) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }

  return /*#__PURE__*/_jsx(HelpArticleTemplate, {
    template: template,
    preview: preview,
    category: category,
    article: faq
  });
};

HelpListPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var smartlingLanguage, _ref2$preview, preview, query;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            smartlingLanguage = _ref2.smartlingLanguage, _ref2$preview = _ref2.preview, preview = _ref2$preview === void 0 ? false : _ref2$preview, query = _ref2.query;
            _context.next = 3;
            return getArticlePageData(query.urlSlug, preview, smartlingLanguage, query.category);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default HelpListPage;